import { Component, Inject, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services/tools/helpers.service';
import { ArchivosPagosService } from '../../../../services/archivos-pagos.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PagosFondeadoresService } from '../../../../services/pagos-fondeadores.service';
import { DatesHelpersService } from '../../../../services/tools/dates-helpers.service';
declare var $;

@Component({
  selector: 'app-pagos-inversion-modal',
  templateUrl: './pagos-inversion-modal.component.html',
  styleUrls: ['./pagos-inversion-modal.component.scss']
})
export class PagosInversionModalComponent implements OnInit {
  public minDate:string = "";
  public isUpdate: boolean = false;
  public idPago: number = 0;
  //public pago: any = {};
  public pago: any = {};
  public saldo_disponible: number = 0;
  public tablaPagos: any[] = [];
  public errors: any = {};
  public archivo: any = null;
  public opcionesPagos: any []  = [];
  public tiposAbonos: any[] = [];
  public tipoPagoSelected: any = '';
  //Para pagos
  public inversiones_con_pagos: any []  = [];
  public index_pago: number = 0;
  public loadingTiposPagos: boolean = false;
  //Para el archivo
  public fileList: FileList;
  //Si va a pagar otro monto
  public otro_monto: boolean = false;
  //Ciclos
  public opcArrayCiclos: any []  = [];
  //Tipo producto
  public esAhorrador: boolean = false;
  public esInversionista: boolean = false;
  //Para retiro final
  isRetiroFinal: boolean = false;
  public isLoading: boolean = false;

  constructor(
    private helperService: HelpersService,
    private datesHelper : DatesHelpersService,
    private archivosService: ArchivosPagosService,
    private pagosFondeadoresService: PagosFondeadoresService,
    public dialogRef: MatDialogRef<PagosInversionModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.inversiones_con_pagos = this.data.inversiones;
    this.saldo_disponible = this.data.saldo;
    console.log("Saldo disponible: ", this.saldo_disponible);
    console.error(this.data)
    this.pago = this.pagosFondeadoresService.getDefaultSchedule();

    this.isRetiroFinal = this.data.pago_final;
    if(this.data.editar != undefined){
      this.isUpdate = this.data.editar;
      console.log("Editar: ", this.isUpdate);
    }

    if(this.data.pago_id != undefined){
      this.idPago = this.data.pago_id;
      console.log("ID Pago: ", this.idPago);

    }
    console.log("Datos: ", this.inversiones_con_pagos);
    console.log("FileList: ", this.fileList);
    console.log("Pago_Final: ", this.isRetiroFinal);

    if(!this.isUpdate){
      let defaultDates = this.datesHelper.getMonthDate();
      this.pago.fecha_pago = defaultDates.fechaFin;
      this.getOpcionesPago();
    }else{
      this.getOpcionesPago();
      this.obtenerPagoUnicoId();
    }
    this.minDate = this.inversiones_con_pagos[0].fecha_inicio_inversion

  }

  public obtenerPagoUnicoId(){
    this.pagosFondeadoresService.getPagoUnicoById(this.idPago)
     .subscribe(response => {
       const datosPagoUnico = response.json();

       console.log("Resp service pago: ",datosPagoUnico);

       if (datosPagoUnico.success) {
        this.pago = datosPagoUnico.content;
        this.pago.numero_ciclo = String(this.pago.numero_ciclo);
        this.pago.monto_anterior = this.pago.monto_pago;
        console.log("Pado Unico: ", this.pago);

       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }

       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
  }

  public close(){
    this.dialogRef.close({pagado:false});
  }

  public realizarPago(){

    this.pago.idEsquemaInversion = Number(this.data.idEsquema);
    this.pago.idFondeador = Number(this.data.idFondeador);
    this.pago.status = 1;
    if(this.pago.tipo_pago == ""){
      this.pago.tipo_pago = null;
    }
    //Validar
    this.errors = this.pagosFondeadoresService.validarPago(this.pago);

    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    this.pago.tipo_pago = 1;
    console.log("Datos del pago: ", this.pago);
    if(!this.isLoading){
      this.isLoading = true;
      this.pagosFondeadoresService.registrarPagoInversion(this.pago, this.fileList)
     .subscribe(response => {
       const datosPago = response.json();

       console.log("Resp service pago: ",datosPago);

       if (datosPago.success) {
         this.helperService.notification('Pago agregado', 'Se ha agrado exitosamente el nuevo pago de inversión', 'success');
         this.dialogRef.close({pagado:true, datos_pago: this.pago});
         this.isLoading = false;
         //setTimeout(() => {window.location.reload()},3000);
       }
     }, error => {
       //this.processing = false;
       this.isLoading = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }

       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
    }else{
      console.log("Esperando a que termine una acción");
    }
  }

  public actualizarPago(){
    //Validar
    this.errors = this.pagosFondeadoresService.validarPago(this.pago);

    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    console.log("Datos del pago a actualizar: ", this.pago);

    this.pagosFondeadoresService.updatePago(this.pago, this.idPago)
     .subscribe(response => {
       const datosPago = response.json();
       if (datosPago.success) {
         this.helperService.notification('Pago actualizado', 'Se ha actualizado exitosamente el pago de inversión seleccionado', 'success');
         this.dialogRef.close({pagado:true, datos_pago: this.pago});
         //setTimeout(() => {window.location.reload()},3000);
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }

       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
  }
  public getOpcionesPago(){
    //console.log("Inversiones: ", this.inversiones_con_pagos);
    if(this.inversiones_con_pagos[0].tipo_producto === "inversionista"){
      this.esInversionista = true;
      if(this.isRetiroFinal){
        let i = this.inversiones_con_pagos.length-1;
        if(this.inversiones_con_pagos[i].fecha_pago != "" && this.inversiones_con_pagos[i].pago_realizado == ""){
          this.opcionesPagos.push({"value":  this.data.intereses, "label": "Retiro final de intereses", "monto": this.data.intereses});
            this.pago.monto_pago = this.data.intereses;
            this.pago.numero_ciclo = String(i);
        }
      }else{
        for (let i = 0; i < this.inversiones_con_pagos.length; i++) {
          if(i == 0){
            if(this.inversiones_con_pagos[i].fecha_pago != "" && this.inversiones_con_pagos[i].pago_realizado == ""){
              this.opcionesPagos.push({"value":  this.inversiones_con_pagos[i].monto, "label": "Pago inicial", "monto": this.inversiones_con_pagos[i].monto});
                this.pago.monto_pago = this.inversiones_con_pagos[i].monto;
                this.pago.numero_ciclo = String(i);
                break;
            }
          }else{
            if(this.inversiones_con_pagos[i].fecha_pago != "" && this.inversiones_con_pagos[i].pago_realizado == ""){
              if(this.inversiones_con_pagos[i].retencion_impuestos == "si"){
                this.opcionesPagos.push({"value":  this.inversiones_con_pagos[i].pago_despues_impuestos, "label": "Pago del periodo", "monto": this.inversiones_con_pagos[i].pago_despues_impuestos});
                this.opcionesPagos.push({"value": 2, "label": "Ingresar otro monto de pago"});
                this.pago.monto_pago = this.inversiones_con_pagos[i].pago_despues_impuestos;
                this.pago.numero_ciclo = String(i);
                break;
              }else{
                this.opcionesPagos.push({"value": this.inversiones_con_pagos[i].pago_interes, "label": "Pago del periodo", "monto": this.inversiones_con_pagos[i].pago_interes});
                this.opcionesPagos.push({"value": 2, "label": "Ingresar otro monto de pago"});
                this.pago.monto_pago = this.inversiones_con_pagos[i].pago_interes;
                this.pago.numero_ciclo = String(i);
                break;
              }
            }
          }
        }
      }
    }else if(this.inversiones_con_pagos[0].tipo_producto === "ahorrador"){
      this.esInversionista = false;
      this.agregarCiclos();
      for (let i = 0; i < this.inversiones_con_pagos.length; i++) {
        if(this.inversiones_con_pagos[i].fecha_pago != "" && this.inversiones_con_pagos[i].pago_realizado == ""){
          this.opcionesPagos.push({"value": this.inversiones_con_pagos[i].monto, "label": "Pago del periodo", "monto": this.inversiones_con_pagos[i].monto});
          this.opcionesPagos.push({"value": 2, "label": "Ingresar otro monto de pago"});
          this.pago.monto_pago = this.inversiones_con_pagos[i].monto;
          //this.pago.numero_ciclo = i;
          break;
        }
      }
    }
  }

  public changeSelect(event: any){
    console.log("Event: ", event);
    var selectElement = event.target;
    var value = selectElement.value;
    console.log("valor: ", value);

    var valor_select = Number(value.split(":")[0].trim());
    console.log("Val: ", valor_select);

    var monto = Number(value.split(":")[1].trim());
    console.log("Monto: ",monto);

    if(!this.esInversionista){
      if(valor_select == 1){
        this.otro_monto = false;
        if(monto > this.saldo_disponible){
          alert("No cuenta con saldo suficiente para realizar el pago");
          this.close();
        }
      }else if(valor_select == 2){
        this.otro_monto = true;
      }
    }else{
      if(valor_select == 2){
        this.otro_monto = true;
      }
    }

  }

  public validarMonto(){
    if(this.pago.monto_pago > this.saldo_disponible){
      alert("No cuenta con saldo suficiente para realizar el pago");
      this.close();
    }
  }

  public agregarCiclos(){
    for (let i = 0; i < this.inversiones_con_pagos.length; i++) {
      if(i == 0){
       if(this.inversiones_con_pagos[i].estatus_pago == ""){
         this.opcArrayCiclos.push({"value": String(this.inversiones_con_pagos[i].mes_numero)});
         break;
       }else if(this.inversiones_con_pagos[i].estatus_pago == "Pagado"){
         this.opcArrayCiclos.push({"value": String(this.inversiones_con_pagos[i].mes_numero)});
       }
      }else if(i > 0){
        if(this.inversiones_con_pagos[i].mes_numero != null){
          if(this.inversiones_con_pagos[i].estatus_pago == ""){
            this.opcArrayCiclos.push({"value": String(this.inversiones_con_pagos[i].mes_numero)});
            break;
          }else if(this.inversiones_con_pagos[i].estatus_pago == "Pagado"){
            this.opcArrayCiclos.push({"value": String(this.inversiones_con_pagos[i].mes_numero)});
          }
        }
      }
    }
    // console.log("Ciclos: ", this.opcArrayCiclos);
  }

  public changeSelectCiclos(event: any){
    console.log("Event: ", event);
    var selectElement = event.target;
    var value = selectElement.value;
    //console.log("Valueee: ", value);
    var valor_select = Number(value.split(":")[0].trim());
    //console.log("Val: ", valor_select);
    if(valor_select != 0){
      var ciclo = (value.split(":")[1].trim());
      console.log("Ciclo: ",ciclo);
      this.minDate = this.data.limites[ciclo].min;
      console.error(this.minDate)
      this.pago.numero_ciclo = ciclo;
    }else{
      this.pago.numero_ciclo = "";
    }
  }

  public uploadFile(event : any) {
    console.log("File: ", event);
    this.fileList = event.target.files;

    if(this.fileList.length > 0) {
        // this.pago.url_archivo = formData;
        // this.pago.nombre_archivo = file.name;
        let file: File = this.fileList[0];
        this.archivo = file.name;
        //formData.append('file', file, file.name);

    }
  }

  public verificarfecha(event:any){
    console.error(event)
    console.log(this.inversiones_con_pagos)
    let monto_temporal=0;
    let min = new Date(this.minDate);
    let fecha = new Date(event);
    if(fecha<min){
      alert("No pude usar una fecha menor a " + this.minDate)
      this.pago.fecha_pago = this.minDate
    }else{
      this.pago.fecha_pago = event;
    }
    if (this.otro_monto){
      for (let index = 0; index < this.inversiones_con_pagos.length; index++) {
        const element = this.inversiones_con_pagos[index];
        if (element.pago_realizado==""){
          let anterior = this.inversiones_con_pagos[index-1]
          console.log("Ultimo pago:")
          // console.log(anterior) 
          let fecha_anrerior = new Date(anterior.fecha_pago);
          // console.log(fecha_anrerior)
          let diff = fecha.getTime() - fecha_anrerior.getTime();
          console.log(diff/(1000*60*60*24) );
          let dias_diff = diff/(1000*60*60*24)
          if (dias_diff>0){
            console.log("Intereses por poner")
            monto_temporal = Math.round(((dias_diff * anterior.tasa_interes_diaria)*anterior.total_inversion + Number.EPSILON) * 100)/100;
            this.pago.monto_pago = monto_temporal
            console.log(monto_temporal)
          }else{
            alert("Selecciona una fecha futura al último pago realizado")
            let next_pago = new Date(element.fecha_pago); 
            this.pago.monto_pago = 0
            // this.pago.fecha_pago = next_pago
          }
          break;
        }
      }
    }
  }

  public downloadFile() {
    this.archivosService.getFile(this.archivo.id).subscribe(
      (response)=>
      {
        const fileUrl = window.URL.createObjectURL(response.blob());
        //Muestra el archivo en una nueva ventana
        window.open(fileUrl);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public deleteFile(){

    this.archivosService.delete(this.archivo.id).subscribe(
      (response)=>
      {
        //Si el archivo fue eliminado, desasignamos el valor del atributo contratoFile
        this.archivo = null;
        this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/pagos-inversion-modal/pagos-inversion-modal.component.ts